import PropTypes from 'prop-types'

export const app = PropTypes.shape({
  upgradeWindowLastShownDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string
  ])
})
